import { HTTP_METHODS } from '@studio/constants/axios';
import { STREAM_USAGE_API_V1 } from '@studio/constants/env-variables';
import type { StreamUsage } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${STREAM_USAGE_API_V1}/customers/@customerId/streams`,
    query: {} as {
      endDate: string;
      startDate: string;
    },
    response: {} as StreamUsage.Get.Stream[],
    method: HTTP_METHODS.GET,
  },
};
